import html2canvas from 'html2canvas'
import {jsPDF} from 'jspdf'

// 不分页打印
export default {
  install (Vue) {
    Vue.prototype.htmlToPdf = function (name, title) {
      html2canvas(document.querySelector('#' + name), {
        // allowTaint: true,
        useCORS: true,
        scale: 2, // 提升画面质量，但是会增加文件大小
        dpi: window.devicePixelRatio
      }).then((canvas) => {
        const contentWidth = canvas.width
        const contentHeight = canvas.height

        /* 导出不分页处理 */
        const pageData = canvas.toDataURL('image/jpeg', 1.0)

        const pdfWidth = contentWidth / 2 * 0.75
        const pdfHeight = (contentHeight + 200) / 2 * 0.75 // 500为底部留白

        const imgWidth = pdfWidth
        const imgHeight = (contentHeight / 2 * 0.75) // 内容图片这里不需要留白的距离

        const PDF = new jsPDF('', 'pt', [pdfWidth + 50, pdfHeight + 100])
        PDF.addImage(pageData, 'jpeg', 33, 0, imgWidth, imgHeight)
        PDF.save(title + '.pdf')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/htmlToPdf.js